// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ajJn1","top":"styles_top__1fsLv"};